import MarketSheet from './index';

export default { path: '/home/hedge/markets/sheet', component: MarketSheet };